import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Droplets } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, fmtDateTime } from "@/lib/api";

export function BacWaterCard() {
  const [s, setS] = useState(null);
  const [log, setLog] = useState([]);
  const [ml, setMl] = useState("");
  const [note, setNote] = useState("");

  const load = () => {
    api.get("/admin/settings").then((r) => setS(r.data));
    api.get("/admin/bac-water/log").then((r) => setLog(r.data.slice(0, 6)));
  };
  useEffect(() => {
    load();
  }, []);

  const adjust = async (sign) => {
    try {
      await api.post("/admin/bac-water/adjust", { delta_ml: sign * Number(ml), note });
      toast.success("BAC water stock updated");
      setMl("");
      setNote("");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  if (!s) return null;
  const low = s.bac_water_stock_ml <= s.bac_water_low_threshold_ml;

  return (
    <div className="mb-8 grid grid-cols-1 gap-6 rounded-lg border border-border border-t-2 border-t-sky-500 bg-card p-6 lg:grid-cols-3" data-testid="bac-water-card">
      <div>
        <p className="eyebrow flex items-center gap-2 text-sky-400"><Droplets className="h-3.5 w-3.5" />BAC water for reconstitution</p>
        <p className={`mt-3 font-mono-data text-4xl ${low ? "text-red-400" : ""}`} data-testid="bac-water-stock-value">{s.bac_water_stock_ml} mL</p>
        <p className="mt-1 text-xs text-muted-foreground">{low ? "Running low — " : ""}alert at {s.bac_water_low_threshold_ml} mL · auto-deducted when you mark a vial reconstituted</p>
      </div>
      <div className="space-y-2">
        <Input type="number" step="0.1" min="0" placeholder="mL" value={ml} onChange={(e) => setMl(e.target.value)} className="font-mono-data" data-testid="bac-adjust-ml-input" />
        <Input placeholder="Note (e.g. new 30 mL bottles)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="bac-adjust-note-input" />
        <div className="flex gap-2">
          <Button disabled={!ml} onClick={() => adjust(1)} data-testid="admin-update-bac-stock-button">Add mL</Button>
          <Button variant="outline" disabled={!ml} onClick={() => adjust(-1)} data-testid="bac-remove-button">Remove mL</Button>
        </div>
      </div>
      <div className="space-y-1.5 text-xs" data-testid="bac-log">
        {log.length === 0 && <p className="text-muted-foreground">No activity yet.</p>}
        {log.map((l) => (
          <div key={l.id} className="flex justify-between gap-2 border-b border-border/50 pb-1">
            <span className="truncate text-muted-foreground">{fmtDateTime(l.created_at)} · {l.note}</span>
            <span className={`font-mono-data ${l.delta_ml < 0 ? "text-red-400" : "text-emerald-400"}`}>{l.delta_ml > 0 ? "+" : ""}{l.delta_ml}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
